import { Pill, Switch } from '@localina/core';
import { FoodBankIcon } from '@localina/icons';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { IRestaurantAreaClosingDay } from '../../../interfaces';

interface IProps {
    area: IRestaurantAreaClosingDay;
    onSwitchChange: (value: boolean, areaId: string) => void;
}

export const AreaBox: React.FC<IProps> = (props) => {
    const { t } = useTranslation();

    return (
        <div className="area-box-item">
            <span className="area-box-item__icon">
                <FoodBankIcon />
            </span>
            <span className="area-box-item__name">{props.area.name}</span>
            <Pill
                tone={props.area.closed ? 'critical' : 'neutral'}
                label={
                    props.area.closed
                        ? t('availability.closingDayView.areaClosed')
                        : t('availability.closingDayView.areaOpen')
                }
            />
            <Switch
                checked={props.area.closed}
                onChange={(value: boolean) => props.onSwitchChange(value, props.area.id)}
            />
        </div>
    );
};
